export default "__VITE_ASSET__aJIfgVf5__"